import { create } from "zustand";
import { CreateFormState } from "./types";

/**
 * Create form store for managing form creation state
 * This store is not persisted as it's temporary state
 */
const useCreateFormStore = create<CreateFormState>()((set) => ({
  name: "새 폼 제목",
  firstMessage: { checked: false, message: "" },
  lastMessage: { checked: false, message: "" },
  agent: { name: "설문자", file: null },
  color: "",
  blocks: [],
  loading: false,
  disabled: false,
  setDisabled: (disabled) => set((state) => ({ ...state, disabled })),
  setName: (name) => set((state) => ({ ...state, name })),
  setLoading: (loading) => set((state) => ({ ...state, loading })),
  setFirstMessage: (checked, message) =>
    set((state) => ({ ...state, firstMessage: { checked, message } })),
  setLastMessage: (checked, message) =>
    set((state) => ({ ...state, lastMessage: { checked, message } })),
  setAgentName: (name) =>
    set((state) => ({ ...state, agent: { ...state.agent, name } })),
  setAgentFile: (file) =>
    set((state) => ({ ...state, agent: { ...state.agent, file } })),
  setColor: (color) => set((state) => ({ ...state, color })),
  addBlock: (block) =>
    set((state) => ({ ...state, blocks: [...state.blocks, block] })),
  removeBlock: (index) =>
    set((state) => ({
      ...state,
      blocks: state.blocks.filter((_, i) => i !== index),
    })),
  updateBlock: (index, block) =>
    set((state) => ({
      ...state,
      blocks: state.blocks.map((b, i) =>
        i === index ? { ...b, ...block } : b
      ),
    })),
  resetAll: () =>
    set((state) => ({
      ...state,
      name: "새 폼 제목",
      firstMessage: { checked: false, message: "" },
      lastMessage: { checked: false, message: "" },
      agent: { name: "설문자", file: null },
      color: "",
      blocks: [],
    })),
}));

export default useCreateFormStore;
